export default __webpack_public_path__ + "static/media/men.f8252ae5.jpg";